import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.prod';
import { Order } from '../model/order.model';
import { Paginated } from '../model/paginated.model';

@Injectable()
export class VentaService extends BaseAPIClass {
  baseUrl = environment.serverBaseUrl;
  baseUrl2: any;
  public isLoading = false;
  private almacenSearchUrl = this.baseUrl + '/ventas/search?term=';
  
  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/ventas';
    this.baseUrl2 = this.baseUrl+'/search';
  }
  getVentas(): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl)
      .toPromise()
      .then(response => {

        
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  ventaDetalle(id: string): Observable<Order> {
    return this.httpClient.get<Order>(this.baseUrl + '/' + id);
  }

  getVentasAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getVentasAtUrl2(pagenumber: number, tipo:any): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
     .get(this.baseUrl2 + "?page="+pagenumber +"&tipo="+ tipo)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  search(term: string,tipo: string): Promise<Paginated> {
    this.isLoading = true;
    const url2 =
      this.almacenSearchUrl +
      term 
      +
      '&tipo=' +
      tipo;
    return this.httpClient
         .get(url2)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }
  /* getExistencia(obje){

  }*/
}
